import { ToolResult } from '../../types/tool.types';
import { ToolContext } from '../tool-context.type';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function setTextureQuality (args: any, context: ToolContext): Promise<ToolResult> {
	const { threeInstance, publish, options } = context;

	const { quality } = args ?? {};
	const isValid = quality === null
		|| (typeof quality === 'number' && quality >= 0 && quality <= 10);
	if (!isValid) {
		return { success: false, error: 'quality parameter must be null or a number between 0 and 10' };
	}

	// Update texture quality in options
	if (options) {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		(options as any).textureQuality = quality;
	}

	// Apply at runtime — delegate handles sky swap/clear with fade; texture
	// manager picks up new anisotropy for subsequent loads. No rebuild.
	if (threeInstance && (threeInstance as { setTextureQuality?: (q: number | null) => Promise<void> }).setTextureQuality) {
		await (threeInstance as { setTextureQuality: (q: number | null) => Promise<void> }).setTextureQuality(quality);
	}

	publish('texture_quality', 'changed', {
		ref: 'quality',
		old: null,
		new: quality
	});

	return { success: true, data: { quality }};
}
